import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileAddFill.tsx
const IconFileAddFill = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 48 48",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "m32 4 10 10v28.016C42 43.112 41.11 44 40.013 44H7.987A2 2 0 0 1 6 42.016V5.984C6 4.888 6.89 4 7.987 4zM22 22h-6v4h6v6h4v-6h6v-4h-6v-6h-4z"
	})]
});
var IconFileAddFill_default = forwardRef(IconFileAddFill);
//#endregion
export { IconFileAddFill_default as default };
